<div class="auto-payments">
  <form [formGroup]="ediaryForm">

    <div class="auto-payments-header">
      <div class="checkbox-wrap">
        <div class="form-group checkbox-input-field">
          <label class="checkbox input-checkbox">
            <input type="checkbox" id="ediaryAutoPaymentEnabled" formControlName="ediaryAutoPaymentEnabled"
                   value="true">
            <span></span>
          </label>
          <label class="checkbox-label" for="ediaryAutoPaymentEnabled">Ediary Auto-payments Enabled</label>
        </div>
      </div>

      <div class="form-group" style="width: 210px" *ngIf="ediaryForm.get('ediaryAutoPaymentEnabled').value">
        <label for="ediaryAutoPaymentCurrency">Auto-payment currency</label>
        <app-dropdown-input #currencySelect id="ediaryAutoPaymentCurrency" [options]="currencies"
                            [parentForm]="ediaryForm" name="ediaryAutoPaymentCurrency"
                            placeholder="Select currency">
        </app-dropdown-input>
      </div>

      <div class="form-group" style="width: 210px" *ngIf="ediaryForm.get('ediaryAutoPaymentEnabled').value">
        <label for="ediaryAutoPaymentAmount">Auto-payment amount</label>
        <input type="number" id="ediaryAutoPaymentAmount" class="form-control"
               formControlName="ediaryAutoPaymentAmount" placeholder="0.00" min="0" step="0.01">
      </div>
    </div>

  </form>

  <div class="auto-payments-footer" style="margin-bottom: 30px;">
    <a routerLink="/trial/{{trialId}}" fragment="policies" class="btn btn-secondary">Cancel</a>
    <button class="btn btn-primary" type="submit" [disabled]="ediaryForm.invalid"
            (click)="onSave()">
      <span *ngIf="ediaryForm.get('isBusy').value">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span class="sr-only">Loading...</span>
      </span>
      <span *ngIf="!ediaryForm.get('isBusy').value">Save</span>
    </button>
  </div>
</div>
